import { css } from '@emotion/react';

export default css`
  --waystation-height: 200px;

  position: relative;
`;

export const pin = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: var(--color-artica-snow);
  translate: -50% -50%;
`;

export const marker = css`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 1px;
  height: var(--waystation-height);
  opacity: 0.5;
  background-image: linear-gradient(
    to bottom,
    var(--color-artica-snow),
    transparent
  );
`;

export const microFlicker = css`
  position: absolute;
  bottom: 0;
  left: 10px;
  width: 50px;
  height: 50px;
  opacity: 0.5;

  &[data-direction="left"] {
    left: auto;
    right: 10px;
  }
`;

export const numbers = css`
  position: absolute;
  bottom: var(--waystation-height);
  left: 5px;
  color: rgb(255 255 255 / 0.5);
  line-height: 1.25;
  font-size: 0.25rem;
  translate: 0 125%;

  i {
    padding-left: var(--pad, 0.25em);
    &:nth-of-type(1) { --pad: 0.75em; }
    &:nth-of-type(2) { --pad: 0.5em; }
    &:nth-of-type(3) { --pad: 0.25em; }
  }

  &[data-direction="left"] {
    left: auto;
    right: calc(100% + 5px);
    text-align: right;
  }
`;

export const noise = css`
  scale: 0.5;
`;